<template>
  <div>
    <Badge
      v-if="status"
      class="shops-signer-status__label"
      :value="[statusLabel, additionalMessage].filter(Boolean).join(' · ')"
      type="outlined"
      :theme="theme"
      :icon="icon"
    />
  </div>
</template>

<script>
import moment from 'moment'
import Badge from '@/components/Badge'

const IconMap = {
  signed: ['fas', 'check-circle'],
  unsigned: ['fal', 'hourglass-start'],
  expired: ['fas', 'exclamation-triangle'],
}

const ThemeMap = {
  signed: 'success',
  unsigned: 'warning',
  expired: 'error',
  default: 'default',
}

const SignedStates = ['accepted', 'signed']

export default {
  props: {
    value: Object,
  },
  computed: {
    contract() {
      return this.value.shop.contract
    },
    categories() {
      return this.$path('categories', this.value.shop) || []
    },
    icon() {
      return IconMap[this.status]
    },
    theme() {
      return ThemeMap[this.status] || ThemeMap.default
    },
    totalSignedCategories() {
      return this.categories.filter(c => SignedStates.includes(c.status)).length
    },
    hasPartials() {
      return (this.$path('contract.data.partials', this.value.shop) || []).length
    },
    master() {
      let signableFrom = this.contract && this.contract.data.signableFrom
      let expiresAt = this.contract && this.contract.expiresAt
      let now = moment()

      return {
        isSigned: this.contract && SignedStates.includes(this.contract.status),
        isSignable: signableFrom && moment(signableFrom).isBefore(now),
        isExpired: expiresAt && moment(expiresAt).isBefore(now),
        isDraft: this.contract && this.contract.status === 'draft',
      }
    },
    status() {
      if (this.value.status !== 'sold') return 'notready'

      if (this.master.expired || this.categories.some(c => c.status === 'expired')) return 'expired'
      if (this.master.isSigned || (this.categories.length && this.totalSignedCategories === this.categories.length))
        return 'signed'
      if (this.master.isSignable || this.categories.some(c => c.status === 'unsigned')) return 'unsigned'
      if (this.master.isDraft || this.categories.some(c => c.status === 'draft')) return 'draft'
    },
    statusLabel() {
      let signed = this.master.isSigned ? 1 : this.totalSignedCategories

      switch (this.status) {
        case 'draft':
          return this.$t('shopBuyerStatusDraft')
        case 'notready':
          return this.$t('projectShopsNotSold')
        default:
          if (this.master.isSigned) return this.$t('shopContractStatusSigned')
          return `${this.$t('shopContractStatusSigned')} ${signed}  ${this.$t('of')} ${
            this.hasPartials ? this.categories.length : 1
          }`
      }
    },
    acceptedMessage() {
      if (this.status !== 'signed' || !this.contract) return
      switch (this.contract.status) {
        case 'accepted':
          return this.$t('contractStatusAccepted').toLowerCase()
        default:
          return this.$t('contractStatusNotAccepted').toLowerCase()
      }
    },
    additionalMessage() {
      if (this.acceptedMessage) return this.acceptedMessage
      if (this.status === 'expired') return this.$t('oneOrMoreDeadlinesExpired')
    },
  },
  components: {
    Badge,
  },
}
</script>
